/* eslint-disable complexity */
import Gikam from '../../../core/gikam-core.js';
import grid from '../vue/grid.vue';
import Base from '../../base.js';
import Vue from 'vue';
import { GridStore } from './gridStore';
import GridExport from './gridExport';
import { I18N } from '@/gikam/i18n/I18N.js';
import { GridColumn, refreshColumnsByConfig } from './gridColumn';
import { getColumnsGroupMap, getColumnGroupRelationship } from './utils';
import { GridUtils } from './grid-utils.js';
import pinyinMatch from 'pinyin-match';
let defaultOptions = {
    id: void 0,
    columns: [],
    url: void 0,
    customSearchData: void 0,
    width: null,
    fieldChangeFlag: true,
    customContent: void 0,
    // 定义工具栏内容，其子组件可为form，button
    toolbar: [],
    // 工具栏中按钮的对齐方式
    toolbarAlign: 'right',
    // 是否可以拖动单元格宽度
    columnResize: true,
    // 请求参数
    requestData: {},
    // 默认排序字段
    order: {},
    // 是否显示分页
    page: true,
    // 当前第几页
    pageNum: 1,
    // 每页显示数量
    pageSize: 50,
    // 显示数据
    data: [],
    // 高度
    height: 400,
    // 总页数
    totalPage: void 0,
    // 数据总数
    totalRecord: 0,
    // 是否显示整个表格
    showBody: true,
    // 是否自动保存
    autoSave: true,
    // 分页中，可选择的每页显示的数量
    pageList: null,
    // 删除时，提示内容对应的格式化方法
    deleteFormatter: rows => rows.id,
    // 启用时，提示内容对应的格式化方法
    activateFormatter: rows => rows.id,
    // 注销时，提示内容对应的格式化方法
    suspendFormatter: rows => rows.id,
    // 是否显示通用查询
    genericQuery: false,
    // 激活行时是否勾选复选框
    checkOnActive: true,
    // 初始化时是否激活字段的change事件
    initTriggerChange: true,
    // 激活行时是否取消其他行的选中
    checkOneOnActive: false,
    // 分组字段
    group: {
        sortEnable: true,
        groupCheckbox: true,
        fields: [],
        formatter: null,
        // 分组节点是否展开
        expand: true
    },
    // 表格列合并 TODO
    columnGroup: null,
    // 组件宽高是否填充满父元素
    fill: false,
    // 快捷查询是否展开
    filterOpen: false,
    // 是否开启快捷查询功能
    filter: true,
    // 自定义功能组['refresh', 'import', 'export'],刷新、导入、导出
    generalButtonGroup: [],
    // 通用按钮组
    generalButtonGroupShow: true,
    // 允许的最大宽度，由父组件传值
    allowWidth: null,
    // 初始化时是否请求数据
    initRequest: true,
    // 编辑器是否可见，为true时，编辑器对应的表头颜色为蓝色，双击编辑器才可对其进行编辑
    editorInvisible: false,
    // 控制单元格文本内容过长是否换行，
    textLineFeed: false,
    // 控制勾选数量角标是否显示
    showCheckedNum: true,
    // 控制列是否充满整个grid(默认true)
    columnsFill: true,
    // 每列的默认宽度（默认为120）
    defaultColumnWidth: 120,
    // 鼠标右击时的菜单选项,例如:[{text:'编辑',icon:'edit',type:'button',onClick:function(){}}]
    contextmenu: [],
    // 需要合计的列以及显示合计要合并的列
    sum: {
        fields: [],
        // 非数字类型字段统计数量
        nonNumberFields: [],
        beginIndex: 0,
        endIndex: 1,
        fixed: false
    },
    // 是否前台筛选
    serverSearch: true,
    // 只读内容对齐状态
    contentAlign: 'left',
    // 实时保存路径
    instantSavePath: void 0,
    // 记录上次设置为只读的索引
    preEditingIndex: void 0,
    // 数据刷新成功后是否激活第一行
    activateFirstRow: false,
    // 表头是否可以选中列
    columnsSelect: false,
    // 隐藏当前grid
    hidden: false,
    // 表头快捷查询数据
    headRequestData: {},
    // 勾选复选框时是否激活行
    activeOnCheck: false,
    // 删除、激活、注销等对列表的操作时，对哪个字段的值进行提示
    confirmField: null,
    // 冻结行，[0, 1，2]代表冻结前3行,暂时支持固定最后合计行
    rowFixed: [],
    firstRowFixed: false,
    // // 'visible'滚动条一直显示，'auto'悬浮时滚动条显示，native原生滚动条
    scroll: 'auto',
    // 初始化时的列 是否先从缓存中去取
    useStorageColumns: true,
    // 表格初始化时是否显示或隐藏顶部工具栏
    toolbarHidden: false,
    // 导出表格数据时，指定下载文件名称
    name: null,
    // 是否显示分页器
    showPagination: true,
    // 快捷查询输入值后是否立即触发
    filterImmediate: false,
    // 记录data数据的数量
    dataMaxLength: 0,
    // 是否显示表格列排序图标
    showSortArrow: false,
    //点击表头是否需要排序
    isSortByHeadClick: true,
    // 在body区域鼠标右键是否会弹窗
    contextMenuConfig: false,
    // 数据存储的表名
    dbTable: '',
    //默认勾选的行
    checkedIds: [],
    // 切换分页时，上页勾选的数据是否有效
    checkContinuous: false,
    // 是否数据锁监控对象
    dataLockWatch: false,
    // 数据锁时，监听的组件id，页面需要监听多个组件时配置
    watchCompId: null,
    // 根元素class
    rootClass: null,
    // 导出Excel文件时是否带有样式
    exportWithStyle: true,
    // 隐藏字段用于编辑页面编辑时使用
    hiddenFields: [],
    // 记录当前grid高级查询策略
    advSearchConfig: [],
    // 是否启用高级查询
    canGeneralRequest: false,
    //高级查询配置
    advancedSearch: {
        // 高级查询显示方式：popup：弹窗展示；top：表格上方展示;
        mode: 'popup',
        /*
            为默认的筛选条件，仅当mode为‘top’时有效
            defaultConfig: [
                    {
                        strategy: 'and',
                        id: 'customGroupId',//组ID
                        data: [
                            {
                                id: 'customItemId',//组内每项ID
                                type: 'string',//字段类型
                                field: '',//字段名称
                                typeItems: [{text: '等于', value：'SEQ'}],//字段类型可选的匹配类型
                                items: [{text: '是', value：1}],//若字段为下拉框时，搜索值的下拉数据
                                typeValue: '',//所选的字段类型的值
                                value: '',//要搜索的值
                                NGOE: '',//范围值，下同，数字大于等于
                                NLOE: '',//数字小于等于
                                TGOE: '',//时间大于等于
                                TLOE: '',//时间小于等于
                                DGOE: '',//日期大于等于
                                DLOE: '',//日期小于等于
                            }
                        ]
                    }
                ]
        */
        defaultConfig: []
    },
    // 配置page:false且lazyLoad:true时，开启懒加载
    lazyLoad: false,
    // 匹配所有列查询
    commonSearch: false,
    // 是否开启 键盘切换编辑器 方向键、Enter、Tab
    enableKeySwitchEditor: true,
    // 激活行时是否切换复选框选中状态,如果行激活，则选中行，之后不再随行激活状态进行切换，除非手动点击复选框取消勾选
    toggleCheckOnActive: true,
    // 导出时配置请求header里面的内容
    exportExcelHeader: 'GIKAM-EXCEL',
    // 数据加载图标样式,normal|retro|progress
    loadingMode: 'progress',
    // 指定数据中主键列，可以配置多个字段即为联合主键
    dataKeyFields: ['id'],
    // 行双击事件
    onRowDblclick: null,
    // 激活行分组时，是否勾选该分组行
    checkOnActiveGroupRow: false,
    // 向通用按钮组中追加按钮
    appendButtonsToGeneral: [],
    // 导出Excel时追加额外的参数
    formatterParamOnExportExcel: param => param,
    // 格式化按键切换单元格编辑器方向(keycode) => {13:'up'|'down'|'left'|'right'}
    formatterKeyDirection: null,
    // 行数据中gridIndex开始的序列号
    gridIndexStart: 0,
    //回车键激活行
    enterKeyDownActive: false,
    // 选中角标超过指定数量时显示
    showCheckedBadgeGt: 1,
    // 是否启用通过url获取数据
    enableGetDataByUrl: true,
    // 全选后角标最大显示条数
    badgeOverflowCount: 99
};

export default class Grid extends Base {
    constructor(options) {
        super('Grid');
        this.$lastChild = true;
        this.getListeners();
        this.canAutoSave = true;
        this.lastRequestData = null;
        this.$changeFields = {};
        this.validators = {};
        // 用于存储选择隐藏的列
        this.hideColumnArray = [];
        // 用于检测是否编辑的字段变量
        this.checkEditorFields = [];
        // 保存计时器，方便清除
        this.timer = null;
        // 移动端改变列宽的遮罩
        this.gridMask = null;
        // 记录校验未通过的字段
        this.errorFields = [];
        // 原生的列
        this.$rawColumns = [];
        // 列管理
        this.columnWrapperManager = {};
        // 顶部工具栏
        this.$gridToolbar = null;
        // 行组件容器
        this.$rowManager = {};
        // 单元格编辑器
        this.editorManager = {};
        // 保留最初的列
        this.initialColumns = options.columns || [];
        this.saveCallBack = null;
        // 记录最后点击的复选框，用于shift按键多选
        this.lastCheckboxRowData = null;
        this.initialize(options, defaultOptions);
        this.oData = Gikam.deepExtend(this.options.data);
        this.$initWindowParam(options);
        this.init();
    }

    /**
     * @description 初始化从window组件传递的参数
     * @private
     * @memberof Grid
     */
    $initWindowParam(options) {
        if (this.$window && this.$window.$param && this.$storeCompIndex === 0) {
            options.requestData = Gikam.extend({}, this.$window.$param, options.requestData);
        }
    }

    getListeners() {
        this.listeners = {
            beforeRefresh: Gikam.emptyFunction,
            beforeLoad: Gikam.emptyFunction,
            cellClick: Gikam.emptyFunction,
            rendered: Gikam.emptyFunction,
            rowActive: Gikam.emptyFunction,
            beforeRowActive: Gikam.emptyFunction,
            columnActive: Gikam.emptyFunction,
            select: Gikam.emptyFunction,
            unSelect: Gikam.emptyFunction,
            allSelect: Gikam.emptyFunction,
            unAllSelect: Gikam.emptyFunction,
            checkboxClick: Gikam.emptyFunction,
            afterChoose: Gikam.emptyFunction,
            loadSuccess: Gikam.emptyFunction,
            updated: Gikam.emptyFunction,
            beforeDelete: json => json,
            beforeActivate: json => json,
            beforeSuspend: json => json,
            beforeUpdate: (data, keys) => [data, keys],
            cellDbClick: Gikam.emptyFunction,
            validating: Gikam.emptyFunction,
            columnsWidthChange: Gikam.emptyFunction,
            loadFail: Gikam.emptyFunction,
            headerClick: Gikam.emptyFunction
        };
    }

    createModel() {
        let _this = this;
        let container = Gikam.createDom('div', this.options.renderTo);
        this.cacheSelectItems(this.options.columns).done(() => {
            this.$rawColumns = Gikam.deepExtend(this.options.columns);
            this.store = new GridStore(this.options, this).store;
            GridUtils.initRowDataList(this);
            this.initColumnsGroupRelationship(this.options.columnGroup);
            this.initColumnsGroupMap();
            this.model = new Vue({
                el: container,
                store: this.store,
                render() {
                    return <grid ref="vm" options={this.options}></grid>;
                },
                provide: { grid: _this },
                components: { grid },
                data() {
                    return { options: _this.options };
                },
                beforeDestroy() {
                    this.$el.removeEventListener('click', _this.clickGrid);
                },
                mounted() {
                    this.$nextTick(() => {
                        this.$el.addEventListener('click', _this.clickGrid.bind(_this), true);
                    });
                }
            });
            this.caseSelectValue();
            if (!this.options.toolbar.find(item => item.type === 'form')) {
                this.refresh();
            }
            this.model.$nextTick(() => {
                this.trigger('rendered');
                this.notify();
            });
        });
    }

    caseSelectValue() {
        const hasItemsData = {};
        this.options.columns
            .filter(function(item) {
                return (
                    ['Select', 'SelectInput', 'ComboBox', 'InsertableSelect'].indexOf(
                        Gikam.toInitialUpperCase(item.type || '')
                    ) > -1 &&
                    item.items &&
                    Gikam.isNotEmpty(item.selectedIndex)
                );
            })
            .forEach(item => {
                item.items[item.selectedIndex] && (hasItemsData[item.field] = item.items[item.selectedIndex].value);
            });

        this.selectIndexValue = hasItemsData;
    }

    clickGrid() {
        if (Gikam.isTrue(this._ignoreClickEvent)) {
            return;
        }
        if (top.Gikam.activeGrid === this) {
            return;
        } else {
            top.Gikam.activeGrid = this;
        }
    }

    setOptions(option) {
        Gikam.extend(true, this.options, option);
        this.store && this.store.commit('setUrl', this.options.url || '');
    }

    getOptions() {
        return Gikam.deepExtend(this.options);
    }

    //与上次查询条件进行比对，条件是否发生变化
    compareRequestData(requestData, lastRequestData) {
        if (this.lastUrl && this.lastUrl !== this.options.url) {
            this.lastUrl = this.options.url;
            return false;
        }
        this.lastUrl = this.options.url;

        if (!lastRequestData) {
            return true;
        }

        if (requestData.s !== lastRequestData.s) {
            return false;
        }

        let result = true;

        Gikam.each(requestData.f, function(key) {
            if (typeof this === 'object') {
                return true;
            }
            if (this !== lastRequestData.f[key]) {
                result = false;
                return false;
            }
        });

        Gikam.each(lastRequestData.f, function(key) {
            if (typeof this === 'object') {
                return true;
            }
            if (this !== requestData.f[key]) {
                result = false;
                return false;
            }
        });

        return result;
    }

    // eslint-disable-next-line complexity
    queryParams(options, pageNum, compare = true) {
        const state = this.store.state;
        this.removeEmptyRequestData();
        const requestData = {
            f: Gikam.extend(true, {}, this.options.requestData, this.options.customSearchData, options),
            n:
                state.pageSize === 'grid.all.data'
                    ? -1
                    : Gikam.isNotEmpty(pageNum)
                    ? pageNum
                    : this.options.page
                    ? state.pageNum
                    : -1,
            s: state.pageSize === 'grid.all.data' ? null : state.pageSize,
            qf: Gikam.deepExtend(state.headRequestData)
        };
        const { fields: numberFields, nonNumberFields } = this.options.sum;

        if (Gikam.isNotEmpty(numberFields)) {
            requestData.tf = numberFields.join(',');
        }
        if (Gikam.isNotEmpty(nonNumberFields)) {
            requestData.cp = nonNumberFields.join(',');
        }
        if (Gikam.isNotEmpty(state.generalRequestData)) {
            requestData.af = state.generalRequestData;
        }
        if (Gikam.isNotEmpty(state.commonSearchData)) {
            requestData.mf = state.commonSearchData;
        }

        requestData.o = this.getOrderArray();

        //条件发生变化，将页面重置为第一页
        //如果当前是第二页，条件发生变革回到第一页开始
        if (compare === true) {
            if (this.compareRequestData(requestData, this.lastRequestData) === false && requestData.n !== -1) {
                requestData.n = 1;
                this.options.pageNum = 1;
            }
            this.lastRequestData = requestData;
        }

        return Gikam.getJsonWrapper(requestData);
    }

    getOrderMap() {
        const orderMap = {};
        //分组字段强制排序
        if (this.options.group?.sortEnable !== false && this.options.group?.fields.length) {
            this.options.group.fields.forEach(ele => {
                orderMap[ele] = 'asc';
            });
        }
        // 排序字段和分组字段合并
        if (!Gikam.isEmptyObject(this.options.order)) {
            for (let key in this.options.order) {
                orderMap[key] = this.options.order[key];
            }
        }
        return orderMap;
    }

    getOrderArray() {
        const orderMap = this.getOrderMap();
        const orderArray = [];
        for (let key in orderMap) {
            let order = {};
            order[key] = orderMap[key];
            orderArray.push(order);
        }
        return orderArray;
    }

    /**
     * @description
     * @memberof Grid
     */
    removeEmptyRequestData() {
        const _this = this;
        if (this.options.requestData) {
            Gikam.each(this.options.requestData, function(key, value) {
                if (Gikam.isEmpty(value)) {
                    delete _this.options.requestData[key];
                }
            });
        }
        const headRequestData = this.store.state.headRequestData;
        if (headRequestData) {
            Gikam.each(headRequestData, function(key, value) {
                if (Gikam.isEmpty(value)) {
                    delete headRequestData[key];
                }
            });
        }
    }

    initColumnsGroupRelationship(columnGroup) {
        if (columnGroup) {
            const relationship = getColumnGroupRelationship(columnGroup);
            this.store.commit('columnsGroup/changeRelationship', relationship);
        }
    }

    initColumnsGroupMap(columns, data) {
        if (Object.keys(this.store.state.columnsGroup.relationship).length) {
            const columnsGroupMap = getColumnsGroupMap(
                columns || this.store.state.columns,
                data || this.options.data,
                this.store.state.columnsGroup.relationship
            );
            this.store.commit('columnsGroup/changeGroupMap', columnsGroupMap);
        }
    }

    /**
     * @private
     * @description 格式化数据
     * @param {*} rows
     * @returns
     * @memberof Grid
     */
    initFormatterRowData(rows) {
        this.initData = [];
        const rowDataList = [];
        if (this.options.checkContinuous) {
            this.dataMapper = this.dataMapper || {};
        } else {
            this.dataMapper = {};
        }
        // options.data为处理之后的数组，其中含有分组的行，initialRowDataList不包含分组行
        this.initialRowDataList = [];
        this.store.commit('setCheckedRowKeys', []);
        rows.forEach((item, index) => {
            this.initData.push(item);
            const rowData = Gikam.deepExtend(this.selectIndexValue, item);
            this.initialRowDataList.push(rowData);
            const key = GridUtils.createRowDataKey(rowData, this);
            // 对外使用的索引，默认从0开始，可自定义
            const rowViewIndex = index + this.options.gridIndexStart;
            item.gridIndex = rowData.gridIndex = rowViewIndex;
            if (Gikam.isEmpty(rowData.index)) {
                item.index = rowData.index = rowViewIndex;
            }
            GridUtils.initRowVueState(rowData, key, this);
            GridUtils.setRowVueState(rowData, 'key', key);
            GridUtils.setRowVueState(rowData, 'rowIndex', index);
            this.dataMapper[key] = rowData;
            if (Gikam.isNotEmpty(this.options.group.fields)) {
                GridUtils.initRowGroup(rowData, rowDataList, this);
            }
            GridUtils.setRowVueState(rowData, 'viewRowIndex', rowDataList.length);
            rowDataList.push(rowData);
        });
        return rowDataList;
    }

    /**
     * @description editorCell是用作TreeGrid方法的，真正含义是加载的时候是否加载子节点
     * @param {*} data
     * @param {*} editorCell
     * @returns
     * @memberof Grid
     */
    refreshByData(data, editorCell) {
        const def = Gikam.getDeferred();
        this.$rowManager = {};
        this.$window && this.$window.changeSaveButtonPrompt(false);
        this.$initPageSearch(data);
        this._setCurrentEditor(null);
        if (this.options.initTriggerChange === false) {
            this.options.fieldChangeFlag = false;
        }
        this.backData = data;
        this.canAutoSave = false;
        const rows = this.trigger('beforeLoad', data.rows) || data.rows;
        data.columnTypeMap && this.store.commit('refreshTypeMapper', data.columnTypeMap);
        this.store.commit('updateTotalRecord', this.backData.total || rows.length);
        if (rows) {
            this.store.commit('setData', this.initFormatterRowData(rows, editorCell));
            this.initColumnsGroupMap();
        }
        if (this.store.state.pageSize === 'grid.all.data') {
            this.store.commit('updateDataLength', this.options.data.length);
        }
        this.model.$children[0].clean();
        this.model.$nextTick(() => {
            this.canAutoSave = true;
            def.resolve();
            this.trigger('loadSuccess', data.rows, data);
            this.options.fieldChangeFlag = true;
            if (Gikam.isEmpty(data.rows)) {
                return;
            }
            if (this.options.activateFirstRow) {
                this.activeRowByIndex(0);
            }
            this.selectRowByIdList(this.options.checkedIds);
            if (editorCell) {
                this.focusOldCell();
            }
            const { scrollLeft } = this.store.state;
            if (scrollLeft > 0) {
                this.store.commit('changeScrollLeft', scrollLeft);
            }
        });
        return def;
    }

    focusOldCell() {
        if (Gikam.isEmpty(this.store.state.activeCoordinate)) {
            return;
        }
        const [rowIndex, colIndex] = this.store.state.activeCoordinate;
        const currentCell = this.model.$refs.vm.$refs[rowIndex + '_' + colIndex];
        if (
            Gikam.isEmpty(currentCell) ||
            currentCell.options.readonly === true ||
            currentCell.$options.name !== 'textInput'
        ) {
            return;
        }
        this.baseFocusField(rowIndex, colIndex, currentCell);
    }

    loadData(data) {
        this.oData = Gikam.deepExtend(data);
        this.refreshByData({ rows: data });
    }

    refresh(param, editorCell) {
        if (
            this.options.autoSave &&
            document.activeElement &&
            this.model &&
            this.model.$el.querySelector('.grid-body').contains(document.activeElement)
        ) {
            this.saveCallBack = () => {
                this.refreshGrid(param, editorCell);
                this.saveCallBack = null;
            };
            document.activeElement.blur();
        } else {
            return this.refreshGrid(param, editorCell);
        }
    }

    refreshGrid(param, editorCell) {
        let _this = this;
        let def = Gikam.getDeferred();
        param && this.setOptions(param);

        if (this.options.enableGetDataByUrl === false) {
            return def.resolve();
        }

        if (param) {
            param.requestData && this.store.commit('changeRequestData', param.requestData);
            param.generalRequestData && this.store.commit('changeGeneralRequestData', param.generalRequestData);
        }
        if (this.trigger('beforeRefresh', this.options.requestData) === false) {
            def.fail();
            return;
        }
        let model = this.model.$children[0];
        if (this.options.url) {
            model.options.data = [];
            this.store.commit('changeRequireState', true);
            Gikam.post(this.options.url, this.queryParams())
                .done((r, status, xhr) => {
                    this.store.state.totalMap = r.totalMap;
                    if (r.pageNumber > 0) {
                        this.store.state.pageNum = r.pageNumber;
                    }
                    if (_this.options.initRequest === false) {
                        if (_this.options.requestData.scheme_only) {
                            delete _this.options.requestData.scheme_only;
                        }
                        _this.options.initRequest = true;
                    }
                    _this.options.totalMap = r.totalMap;
                    _this.refreshByData(r, editorCell).done(() => {
                        def.resolve(_this);
                    });
                    this.storeInstantSavePath(xhr);
                    const gridComp = this.model.$children[0];
                    gridComp.showRowFixedBottom = false;
                    gridComp.showRowFixedTop = false;
                    const { scrollTop } = this.store.state;
                    scrollTop > 0 && this.store.commit('changeScrollTop', scrollTop + 2);
                    this.model.$nextTick(() => {
                        gridComp.handleRowFixed();
                        setTimeout(() => {
                            scrollTop > 0 && this.store.commit('changeScrollTop', scrollTop);
                        }, 300);
                    });
                    this.store.commit('changeRequireState', false);
                })
                .fail(r => {
                    _this.model.$nextTick(() => {
                        _this.trigger('loadFail', r);
                    });
                    this.store.commit('changeRequireState', false);
                    def.reject(r);
                });
        } else {
            this.options.data = this.oData.length
                ? Gikam.deepExtend(this.oData)
                : this.options.data.filter(ele => !ele._vueState || ele._vueState.rowType !== 'group');
            this.sortData(this.options.data);
            if (Gikam.isNotEmpty(this.options.data)) {
                this.options.data.forEach(item => {
                    for (let key in this.selectIndexValue) {
                        if (Gikam.isEmpty(item[key])) {
                            item[key] = this.selectIndexValue[key];
                        }
                    }
                });
            }
            this.refreshByData({ rows: this.options.data });
            def.resolve();
        }
        // 刷新列表的时候把字段校验没通过的信息给清空
        this.cleanValidateCache();
        this.initDataLock();
        return def;
    }

    refreshNoFieldChange(param) {
        this.options.fieldChangeFlag = false;
        let _this = this;
        this.refresh(param).done(() => {
            _this.options.fieldChangeFlag = true;
        });
    }

    /**
     * @private
     * @description 用于底层使用
     * @memberof Grid
     */
    getTotalData() {
        if (!this.isLazyLoad()) {
            return this.options.data;
        }
        return this.store.state.lazyLoad.totalRows;
    }

    getSelections() {
        if (this.options.checkContinuous) {
            if (this.model.$refs.vm.allChecked) {
                return this.store.state.allCheckContinuousData;
            } else {
                return Object.values(this.store.state.checkedStorage);
            }
        } else {
            return this.model.$children[0].getSelections();
        }
    }

    /**
     * @description 获取加载的所有数据
     * @returns
     * @memberof Grid
     */
    getData() {
        const rowDataList = [];
        this.initialRowDataList?.forEach(row => {
            const deepData = Gikam.deepExtend(row);
            GridUtils.removeAllRowVueState(deepData);
            rowDataList.push(deepData);
        });
        return rowDataList;
    }

    /**
     * @description 缓存所有下拉框选项值
     * @private
     * @param {Array} 需要筛选的字段配置参数
     * @returns
     * @memberof Grid
     */
    cacheSelectItems(columns) {
        let filterType = ['Select', 'SelectInput', 'ComboBox', 'InsertableSelect', 'CascadeSelect'];
        const filterSelectFields = function(item) {
            return filterType.indexOf(Gikam.toInitialUpperCase(item.type || '')) > -1 && Gikam.isEmpty(item.items);
        };
        let codeArray = columns.filter(filterSelectFields);
        const toolbarForm = this.options.toolbar.find(item => item.type === 'form');
        if (toolbarForm) {
            codeArray.push(...toolbarForm.fields.filter(filterSelectFields));
        }
        if (Gikam.isEmpty(codeArray)) {
            return Gikam.getDeferred().resolve();
        }
        return Gikam.select.cacheItems(codeArray);
    }

    refreshRowByIndex(index) {
        const def = Gikam.getDeferred();
        const oldRowData = this.initialRowDataList[index];
        const queryData = this.queryParams({ id_EQ: oldRowData.id }, 1, false);
        Gikam.post(this.options.url, queryData).done(data => {
            if (Gikam.isEmpty(data.rows)) {
                GridUtils.removeRow(oldRowData, this);
            } else {
                GridUtils.replaceViewRow(oldRowData, data.rows[0], this);
            }
            def.resolve();
        });
        return def;
    }

    removeRow(row) {
        GridUtils.removeRow(row, this);
    }

    /**
     *
     * 通过id向后台发起请求,刷新此条数据
     * @param {String,Number} id
     * @returns
     * @memberof Grid
     */
    refreshRowById(id) {
        if (Gikam.isEmpty(id)) {
            return;
        }
        const rowIndex = GridUtils.getRowVueState(this.dataMapper[id], 'rowIndex');
        this.refreshRowByIndex(rowIndex);
    }

    /**
     * @description
     * @param {*} url
     * @param {*} selectRows
     * @returns
     * @memberof Grid
     * @public
     */
    deleteRows(url, selectRows) {
        const _this = this;
        const options = {
            url: url,
            confirm: {
                msg: 'GIKAM.TIP.CONFIRM_TO_DELETE_FOLLOWING_ITEMS', // 确认弹出框中左侧的信息
                title: 'GIKAM.TIP.CONFIRM_TO_DELETE'
            },
            formatter: function(row) {
                return _this.options.deleteFormatter(row);
            },
            // 提交前处理json数据的方法
            beforeProcess: 'beforeDelete',
            // 调用的Html请求的方法
            method: 'del',
            // 自定义删除的数据
            data: selectRows
        };

        return this.processRows(options);
    }

    activateRows(url) {
        let _this = this,
            options = {
                url: url,
                flag: {
                    name: 'activatedFlag',
                    expectedValue: '0',
                    unexpectedMsg: 'GIKAM.TIP.CHOOSE_DEACTIVATED_ITEM'
                },
                confirm: {
                    msg: 'GIKAM.TIP.WHETHER_TO_ACTIVATE_FOLLOWING_ITEMS',
                    title: 'GIKAM.TIP.CONFIRM_TO_ACTIVATE'
                },
                formatter: function(row) {
                    return _this.options.activateFormatter(row);
                },
                beforeProcess: 'beforeActivate'
            };

        return _this.processRows(options);
    }

    deactivateRows(url) {
        let _this = this;
        let options = {
            url: url,
            flag: {
                name: 'activatedFlag',
                expectedValue: '1',
                unexpectedMsg: 'GIKAM.TIP.CHOOSE_ACTIVATED_ITEM'
            },
            confirm: {
                msg: 'GIKAM.TIP.WHETHER_TO_DEACTIVATE_FOLLOWING_ITEMS',
                title: 'GIKAM.TIP.CONFIRM_TO_DEACTIVATE'
            },
            formatter: function(row) {
                return _this.options.activateFormatter(row);
            },
            beforeProcess: 'beforeActivate'
        };

        return _this.processRows(options);
    }

    suspendRows(url) {
        let _this = this,
            options = {
                url: url,
                flag: {
                    name: 'lastSuspendedFlag',
                    expectedValue: '0',
                    unexpectedMsg: 'GIKAM.TIP.CHOOSE_UNSUSPENDED_ITEM'
                },
                confirm: {
                    msg: 'GIKAM.TIP.WHETHER_TO_SUSPEND_FOLLOWING_ITEMS',
                    title: 'GIKAM.TIP.CONFIRM_TO_SUSPEND'
                },
                formatter: function(row) {
                    return _this.options.suspendFormatter(row);
                },
                beforeProcess: 'beforeSuspend'
            };

        return _this.processRows(options);
    }

    unsuspendRows(url) {
        let _this = this,
            options = {
                url: url,
                flag: {
                    name: 'lastSuspendedFlag',
                    expectedValue: '1',
                    unexpectedMsg: 'GIKAM.TIP.CHOOSE_SUSPENDED_ITEM'
                },
                confirm: {
                    msg: 'GIKAM.TIP.WHETHER_TO_UNSUSPEND_FOLLOWING_ITEMS',
                    title: 'GIKAM.TIP.CONFIRM_TO_UNSUSPEND'
                },
                formatter: function(row) {
                    return _this.options.suspendFormatter(row);
                },
                beforeProcess: 'beforeSuspend'
            };

        return _this.processRows(options);
    }

    /**
     * @description
     * @param {*} options
     * @returns
     * @memberof Grid
     * @private
     */
    getProcessRowsData(options) {
        return options.data || this.getSelections();
    }

    processRows(options) {
        let def = Gikam.getDeferred();
        const selectedRows = this.getProcessRowsData(options);
        if (Gikam.isEmpty(selectedRows)) {
            Gikam.alert('GIKAM.TIP.CHOOSE_AT_LEAST_ONE_ITEM');
            return def;
        }
        if (options.onlyOne === true && selectedRows.length !== 1) {
            Gikam.alert('GIKAM.TIP.CHOOSE_ONE_ITEM');
            return def;
        }
        if (options.flag) {
            let valid = true;
            selectedRows.forEach(function(row) {
                if (row[options.flag.name] !== options.flag.expectedValue) {
                    valid = false;
                }
            });
            if (!valid) {
                Gikam.alert(options.flag.unexpectedMsg);
                return def;
            }
        }
        let _this = this;
        let selectedRowsJson = selectedRows.map(row => {
            return { id: row.id };
        });
        let selectedHtml = selectedRows.reduce(function(total, row) {
            return (total +=
                '<div style="padding-top:5px;">' + _this.getProcessConfirmFieldValue(row, options) + '</div>');
        }, '');

        let params = null;
        if (options.beforeProcess) {
            if (Gikam.isString(options.beforeProcess)) {
                params = _this.trigger(options.beforeProcess, selectedRowsJson, selectedRows);
            } else if (Gikam.isFunction(options.beforeProcess)) {
                params = options.beforeProcess(selectedRowsJson, selectedRows);
            }
        }

        Gikam.create('confirm', {
            title: Gikam.propI18N(options.confirm.title),
            subTitle: Gikam.propI18N(options.confirm.msg),
            message: selectedHtml,
            height: 250,
            rootClass: 'grid-confirm',
            onYesClick: function() {
                if (Gikam.isNotEmpty(_this.$window)) {
                    _this.$window.showMask(true);
                }
                Gikam[options.method ? options.method : 'put'](
                    options.url,
                    Gikam.getJsonWrapper(null, ['', params ? params : selectedRowsJson])
                )
                    .done(function(r) {
                        if (options.gridRefresh !== false) {
                            _this.refresh().done(() => {
                                def.resolve(r);
                            });
                        } else {
                            def.resolve(r);
                        }
                    })
                    .always(function() {
                        if (Gikam.isNotEmpty(_this.$window)) {
                            _this.$window.closeMask(true);
                        }
                    });
            }
        });

        return def;
    }

    /**
     * @description 针对列表的操作，提示的字段值
     * @memberof Grid
     * @private
     */
    getProcessConfirmFieldValue(row, options) {
        const confirmField = this.options.confirmField;
        if (confirmField) {
            const fieldOption = this.options.columns.filter(item => item.field === confirmField)[0];
            const fieldValue = Gikam.getFieldValue(row, confirmField);
            if (!fieldOption || Gikam.isEmpty(fieldValue)) {
                return '';
            }
            if (fieldOption.type === 'select') {
                const selectItem = fieldOption.items.filter(item => item.value.toString() === fieldValue.toString())[0];
                return selectItem ? selectItem.text : '';
            }
            return fieldValue;
        }
        return options.formatter ? options.formatter(row) : row.id;
    }

    /**
     * @description 表格导出excel
     * @public
     * @param {String} rows 导出的文件名称
     * @param {Boolean} rows 导出使用的url
     * @param {Boolean} rows 导出时是否选中导出列
     * @memberof Grid
     */
    exportExcel(...arg) {
        const _url = arg[1] || this.options.url;
        if (!_url) {
            return;
        }
        const params = this.options.formatterParamOnExportExcel.call(this, JSON.parse(this.queryParams()).p);
        const selectionIds = this.getSelections()
            .map(item => item.id)
            .join(',');
        const options = Gikam.deepExtend({
            arg: arg,
            url: _url,
            grigFileName: this.options.name,
            params: params,
            store: this.store,
            dataIds: selectionIds,
            gridOptions: this.options
        });
        new GridExport(options);
    }

    /**
     * @description 获取激活的行数据
     * @returns
     * @memberof Grid
     */
    getActivedRow() {
        const activeRowDataKey = this.store.state.activeRowDataKey;
        if (!activeRowDataKey) {
            return null;
        }
        return Gikam.deepExtend(this.dataMapper[activeRowDataKey]);
    }

    getActivedColumn() {
        const columns = this.store.state.columns;
        const selectIndex = this.store.state.chooseColumns.columnsSelectIndex;
        if (Gikam.isEmpty(columns) || !Gikam.isNumber(selectIndex)) {
            return '';
        }
        return columns[selectIndex] ? columns[selectIndex].field : '';
    }

    getColumns() {
        return Gikam.deepExtend(this.store.state.columns);
    }

    cleanActivedColumn() {
        this.store.commit('chooseColumns/changeColumnsSelectIndex', null);
    }

    async setData(param, autoSaveFlag = true, cleanRowData) {
        if (Gikam.isEmpty(param.index) && Gikam.isEmpty(param.id)) {
            Gikam.error('No index or id was found when updating data');
        }
        this.canAutoSave = false;
        let index = param.index;
        let row = Gikam.isNotEmpty(param.index) ? this.initialRowDataList[param.index] : this.dataMapper[param.id];
        if (!row) {
            Gikam.error('No updated data was found');
            return;
        }
        let data = Gikam.deepExtend(row, param);
        if (cleanRowData) {
            if (!param.id) {
                param.id = row.id;
            }
            data = param;
        }
        if (Gikam.isNotEmpty(data.index)) {
            delete data.index;
        }
        GridUtils.replaceViewRow(row, data, this);
        this.store.state.lazyLoad.totalRows[index] = data;
        await this.model.$nextTick();
        this.canAutoSave = true;
        if (autoSaveFlag) {
            return this.autoSave(param);
        } else {
            return Promise.resolve();
        }
    }

    /**
     *
     * @description 校验表格中数据是否满足规则，也可以校验指定行数据
     * @public
     * @param {Array} rows 校验指定的数据
     * @returns
     * @memberof Grid
     */
    validate(rows, noModal) {
        document.body.click();
        if (this.validateExistsError(rows, noModal) === false) {
            return false;
        }
        let _this = this;
        let error = [];
        const data = Gikam.isNotEmpty(rows) ? rows : this.initialRowDataList;
        Gikam.each(data, function(rowIndex) {
            if (Gikam.isNotEmpty(this._groupIndex)) {
                return true;
            }
            let rowValidateResult = true;
            let data = this;
            Gikam.each(_this.validators, function(field) {
                let errorMessage = [];
                let errorResult = true;
                Gikam.each(this, function() {
                    // 唯一性校验，在调用validate方法时不验证
                    if (['unique', 'remote'].includes(this.type)) {
                        return true;
                    }
                    let r = Gikam.validator[this.type](
                        Gikam.getFieldValue(data, field),
                        this.rule,
                        field,
                        data.id,
                        Gikam.extend(this, { data })
                    );
                    if (r.result === false) {
                        error.push({
                            field: field,
                            title: this.title,
                            message: r.message
                        });
                        errorMessage.push({
                            field: field,
                            title: this.title,
                            message: r.message
                        });
                        rowValidateResult = false;
                        errorResult = false;
                    }
                });
                let fieldNumber;
                for (let i = 0; i < _this.options.columns.length; i++) {
                    if (_this.options.columns[i].field === field) {
                        fieldNumber = i;
                    }
                }
                let rowDataIndex = rowIndex;
                if (Gikam.isNotEmpty(rows)) {
                    rowDataIndex = GridUtils.getRowVueState(_this.dataMapper[data.id], 'rowIndex');
                }
                const fieldRef = `${rowDataIndex}_${fieldNumber}`;
                const childComp = _this.model.$children[0].$refs[fieldRef];
                if (childComp) {
                    childComp.validateResult = errorResult;
                    if (Gikam.isFalse(childComp.validateResult)) {
                        childComp.error = errorMessage;
                    }
                }
            });

            const projectValidate = _this.trigger('validating', data);

            if (
                Gikam.isPlainObject(projectValidate) &&
                Gikam.isFalse(projectValidate.result) &&
                Gikam.isNotEmpty(projectValidate.message)
            ) {
                projectValidate.title = '';
                error.push(projectValidate);
                rowValidateResult = false;
            }

            if (rowValidateResult === false) {
                return false;
            }
        });

        if (Gikam.isEmpty(error)) {
            return true;
        } else {
            noModal !== true && this.showValidateMessage(error);
            return false;
        }
    }

    showValidateMessage(error) {
        let tpl =
            '<div class="validator-error-container">' +
            '<span class="error-title">' +
            Gikam.propI18N('GIKAM.TIP.INVALID_INPUT_FIELDS') +
            '</span>' +
            '<div class="error-zone">{errorMessage}</div>' +
            '</div>';
        let errorMessage = '';
        error.forEach(function(item) {
            if (item.title) {
                errorMessage +=
                    '<div>' +
                    '<span class="error-field-desc">' +
                    Gikam.propI18N(item.title) +
                    '</span>' +
                    Gikam.propI18N(item.message) +
                    '</div>';
            } else {
                errorMessage += '<div>' + Gikam.propI18N(item.message) + '</div>';
            }
        });

        Gikam.alert(
            Gikam.printf(tpl, {
                errorMessage: errorMessage
            }),
            200
        );
    }

    insert(url, data, param) {
        let _this = this;
        let def = Gikam.getDeferred();
        let json = Gikam.getJsonWrapper(param, data ? ['', data] : null);
        let window = this.$window;
        if (!window) {
            window = Gikam.getInstance(Gikam.jQuery(this.model.$el).closest('.window'));
        }
        window.showMask(true);
        Gikam.postText(url, json)
            .done(function(id) {
                def.resolve(id);
                _this.refresh();
            })
            .always(function() {
                window.closeMask();
            });
        return def;
    }

    moveUp(url) {
        let selections = this.getSelections();
        let def = Gikam.getDeferred();
        let data = this.initialRowDataList;
        if (Gikam.isEmpty(selections)) {
            Gikam.alert('GIKAM.TIP.MOVE_UP.NO_NODE_SELECTED');
            return def;
        }
        if (selections.length > 1) {
            Gikam.alert('GIKAM.TIP.MOVE_UP.MULTIPLE_NODES_SELECTED');
            return def;
        }
        const checkedRowKeys = this.store.state.checkedRowKeys;
        let selectedIndex = GridUtils.getRowVueState(this.dataMapper[checkedRowKeys[0]], 'rowIndex');
        if (selectedIndex === 0) {
            Gikam.alert('GIKAM.TIP.MOVE_UP.TOP_NODE_SELECTED');
            return def;
        }
        if (Gikam.isNotEmpty(this.lastRequestData.o)) {
            if (Object.getOwnPropertyNames(this.lastRequestData.o[0])[0] !== 'orderNo') {
                Gikam.alert(I18N.prop('grid.tip.do.not.move.up'));
                return def;
            }
        }

        this.$window.showMask(true);
        Gikam.put(
            Gikam.printf(url, {
                firstId: data[selectedIndex].id,
                secondId: data[selectedIndex - 1].id
            })
        )
            .done(() => {
                this.refresh().done(() => {
                    this.selectRowByIndex(selectedIndex - 1);
                    def.resolve();
                });
            })
            .always(() => {
                this.$window.closeMask();
            });
        return def;
    }

    moveDown(url) {
        let selections = this.getSelections();
        let data = this.initialRowDataList;
        let def = Gikam.getDeferred();
        if (Gikam.isEmpty(selections)) {
            Gikam.alert('GIKAM.TIP.MOVE_DOWN.NO_NODE_SELECTED');
            return def;
        }
        if (selections.length > 1) {
            Gikam.alert('GIKAM.TIP.MOVE_DOWN.MULTIPLE_NODES_SELECTED');
            return def;
        }
        const checkedRowKeys = this.store.state.checkedRowKeys;
        let selectedIndex = GridUtils.getRowVueState(this.dataMapper[checkedRowKeys[0]], 'rowIndex');
        if (selectedIndex === data.length - 1) {
            Gikam.alert('GIKAM.TIP.MOVE_DOWN.BOTTOM_NODE_SELECTED');
            return def;
        }
        if (Gikam.isNotEmpty(this.lastRequestData.o)) {
            if (Object.getOwnPropertyNames(this.lastRequestData.o[0])[0] !== 'orderNo') {
                Gikam.alert(I18N.prop('grid.tip.do.not.move.up'));
                return def;
            }
        }
        this.$window.showMask();
        Gikam.put(
            Gikam.printf(url, {
                firstId: data[selectedIndex].id,
                secondId: data[selectedIndex + 1].id
            })
        )
            .done(() => {
                this.refresh().done(() => {
                    this.selectRowByIndex(selectedIndex + 1);
                    def.resolve();
                });
            })
            .always(() => {
                this.$window.closeMask();
            });
        return def;
    }

    /**
     * @description 通过索引激活行
     * @param {*} index
     * @returns
     * @memberof Grid
     */
    activeRowByIndex(index) {
        const rowDataList = this.initialRowDataList;
        let rowIndex = index;
        if (Gikam.isEmpty(rowDataList) || !Gikam.isNumber(index)) {
            return;
        }
        if (index > rowDataList.length - 1) {
            rowIndex = rowDataList.length - 1;
        }
        const rowData = rowDataList[rowIndex];
        GridUtils.activeRow(rowData, this);
        this.scrollToRowId(rowData.id);
    }

    /**
     * @description 取消激活行
     * @returns
     * @memberof Grid
     */

    cleanActiveRow(checked) {
        let param = { grid: this, checked: checked };
        this.store.commit('cleanActiveRow', param);
    }

    /**
     * @description 定位竖向滚动条
     * @private
     * @memberof Grid
     */
    _positionScrollY(id) {
        if (Gikam.isEmpty(id)) {
            return false;
        }
        const fieldComp = this.model.$refs.vm.$refs['row-' + id][0];
        const gridVue = this.model.$refs.vm;
        const wrapperHeight = gridVue.$refs['vs'].$el.offsetHeight;
        const cellDomHeight = fieldComp.offsetHeight;
        const cellDomTop = fieldComp.offsetTop;
        const { scrollTop } = gridVue.$refs['vs'].getPosition();

        if (scrollTop > cellDomTop || wrapperHeight + scrollTop < cellDomTop + cellDomHeight) {
            gridVue.transition = false;
            gridVue.$refs.vs.scrollTo({ y: cellDomTop - wrapperHeight + cellDomHeight });
            setTimeout(() => {
                gridVue.transition = true;
            }, 0);
            return true;
        } else {
            return false;
        }
    }

    checkAll() {
        this.store.commit('setAllChecked', true);
    }

    unCheckAll() {
        this.store.commit('setAllChecked', false);
    }

    selectRowByIndex(index) {
        GridUtils.checkRow(this.initialRowDataList[index], this);
    }

    unSelectRowByIndex(index) {
        GridUtils.unCheckRow(this.initialRowDataList[index], this);
    }

    selectRowById(id) {
        GridUtils.checkRow(this.dataMapper[id], this);
    }

    unSelectRowById(id) {
        GridUtils.unCheckRow(this.dataMapper[id], this);
    }

    selectRowByIdList(idList) {
        idList.forEach(id => this.selectRowById(id));
    }

    setReadonlyParam(isReadonly) {
        this.options.columns
            .filter(function(column) {
                return Gikam.isNotEmpty(column.editor);
            })
            .forEach(function(column) {
                column.editor = !isReadonly;
            });
    }

    //批量只读设置
    setReadonly(isReadonly) {
        let readonly = Gikam.isEmpty(isReadonly) ? true : isReadonly;
        this.setReadonlyParam(readonly);
        this.refresh();
    }

    toFieldsReadonly(index, fields) {
        if (!Gikam.isNumber(index)) {
            Gikam.error(`index ${index} is not a validate number`);
        }
        this.model.$children[0].setFieldsReadonly(index, fields, true);
    }

    toFieldsEdit(index, fields) {
        if (!Gikam.isNumber(index)) {
            Gikam.error(`index ${index} is not a validate number`);
        }
        this.model.$children[0].setFieldsReadonly(index, fields, false);
    }

    hideBody() {
        this.options.showBody = false;
        return this;
    }

    showBody() {
        this.options.showBody = true;
        return this;
    }

    showPagination() {
        this.options.showPagination = true;
        return this;
    }

    hidePagination() {
        this.options.showPagination = false;
        return this;
    }

    //追加内容到表格之后，此方法与hideBody配合使用，表格部分隐藏之后，再追加内容
    appendContent(content) {
        this.options.customContent = content;
        return this;
    }

    cleanData() {
        this.refreshByData({
            rows: [],
            total: 0,
            pageNumber: 0
        });
    }

    formatterPageList() {
        this.options.pageList = this.options.pageList ?? [50, 100, 200, 'grid.all.data'];
        this.options.pageList = this.options.pageList.map(item => {
            return {
                value: item,
                text: item === 'grid.all.data' ? I18N.prop(item) : item + I18N.prop('grid.pageValue')
            };
        });
    }

    watchColumns() {
        let columns = this.options.columns;
        const _this = this;
        Object.defineProperty(this.options, 'columns', {
            set(value) {
                columns = value;
                setTimeout(() => {
                    const repeatColumns = [];
                    columns.forEach(column => {
                        if (column.checkbox || column.index || column.radio) {
                            return;
                        }
                        if (Gikam.isEmpty(column.field)) {
                            Gikam.error(`field require not empty in Grid [${_this.options.id}]`);
                        } else {
                            if (repeatColumns.includes(column.field)) {
                                Gikam.error(`column [${column.field}] repeat in Grid [${_this.options.id}]`);
                            } else {
                                repeatColumns.push(column.field);
                            }
                        }
                    });
                }, 200);
            },
            get() {
                return columns;
            }
        });
    }

    /**
     * @description 传入fields隐藏指定列
     * @public
     * @param {Array} 包含field字符串的数组
     * @memberof Grid
     */ deleteFormatter;
    hideColumns(fields) {
        //获取当前columns数组
        let columns = this.store.state.columns.slice();

        //获取隐藏columns数组
        let tempHiddenColumns = this.hideColumnArray;

        //计算隐藏列原始位置
        let computedIndex = 0;
        let hiddenFields = [];
        //还原原始columns(避免循环调用隐藏指定列导致的位置错乱问题)
        for (let i = tempHiddenColumns.length - 1; i >= 0; i--) {
            //记录位置减空余位置，计算得出原始位置
            let index = this.hideColumnArray[i].columnsIndex - computedIndex;
            columns.splice(index, 0, this.hideColumnArray[i].field);
            hiddenFields.push(this.hideColumnArray[i].field.field);
            computedIndex += 1;
        }

        this.hideColumnArray = [];
        for (let i = columns.length - 1; i >= 0; i--) {
            //判断当前列是否为隐藏列
            if (columns[i].field && fields.concat(hiddenFields).indexOf(columns[i].field) !== -1) {
                //保存隐藏字段
                this.hideColumnArray.push({ columnsIndex: i, field: columns[i] });
                //删除当前渲染列
                columns.splice(i, 1);
            }
        }
        this.store.commit('refreshColumns', columns);
    }

    /**
     * @description 通过传入field显示被隐藏的列
     * @public
     * @param {Array} 包含field字符串的数组
     * @memberof Grid
     */
    showColumns(fields) {
        //获取当前隐藏列数组
        let hiddenColumns = this.hideColumnArray;
        //用于计算原始位置
        let computedIndex = 0;

        let columns = this.store.state.columns.slice();

        for (let i = hiddenColumns.length - 1; i >= 0; i--) {
            if (fields.indexOf(hiddenColumns[i].field.field) !== -1) {
                //记录位置减空余位置，计算得出原始位置
                let index = this.hideColumnArray[i].columnsIndex - computedIndex;
                columns.splice(index, 0, this.hideColumnArray[i].field);
                this.hideColumnArray.splice(i, 1);
            } else {
                computedIndex += 1;
            }
        }
        this.store.commit('refreshColumns', columns);
    }

    /**
     * @description 隐藏或显示当前grid
     * @public
     * @param {Boolean} 隐藏 true, 显示 false
     * @memberof Grid
     */
    setHidden(arg) {
        this.model.$refs.vm.changeHiddenGridState(arg);
    }

    /* 
    私有方法
    自动保存时使用，用于获取字段的type和items
     */
    getFieldInfoByData(data, index) {
        const fieldInfo = {};
        this.options.columns.forEach(columnOptions => {
            if (
                Gikam.isNotEmpty(data[columnOptions.field], true) &&
                ['select', 'simpleCheckbox'].indexOf(columnOptions.type) > -1
            ) {
                const options = {
                    type: columnOptions.type === 'simpleCheckbox' ? 'checkbox' : columnOptions.type || 'text'
                };
                if (columnOptions.type === 'select') {
                    const selectEditor = this.getField(
                        Gikam.isNotEmpty(index) ? index : this.getIndexByDataId(data.id),
                        columnOptions.field
                    );
                    const items = (selectEditor || columnOptions).items?.map(item => {
                        return { text: item.text, value: item.value };
                    });
                    options.items = items;
                }
                fieldInfo[columnOptions.field] = options;
            }
        });
        return fieldInfo;
    }

    autoSave(data, header) {
        if (!this.options.autoSave) {
            return Promise.resolve();
        }
        //审计跟踪来源
        Gikam.buttonText = '保存';
        const realData = this.trigger('beforeUpdate', data, Object.keys(data));
        if (realData === false) {
            return Promise.resolve();
        }
        if (Gikam.isPlainObject(realData) && !Gikam.isEmptyObject(realData)) {
            data = realData;
        }
        if (!this.options.instantSavePath) {
            return Promise.resolve();
        }
        if (Gikam.isEmpty(data.id)) {
            data.id = data.row ? data.row.id : this.initialRowDataList[data.index].id;
        }
        // 例如data:{id:1,field1:'123'},row:{ext${field1_ext$:{}}},则将field1的属性合并到data中
        const updateFields = Object.getOwnPropertyNames(data).filter(
            item => !['id', 'index', 'row', 'ext$'].includes(item)
        );
        if (updateFields.length === 1 && data.row && data.row.ext$) {
            const preStr = updateFields[0] + '_ext$';
            const fieldData = data.row.ext$[preStr];
            Gikam.each(fieldData, function(field) {
                if (field === '$field') {
                    data[fieldData[field]] = data[updateFields[0]];
                    delete data[updateFields[0]];
                } else {
                    data[field] = fieldData[field];
                }
            });
        }
        const index = data.index;
        delete data.index;
        delete data.row;

        return new Promise((resolve, reject) => {
            Gikam.put(
                this.getInstantSavePath(data),
                Gikam.getJsonWrapper({ t: this.getFieldInfoByData(data, index) }, [this.options.service, [data]]),
                header
            )
                .done(() => {
                    if (this.saveCallBack) {
                        this.saveCallBack();
                    }
                    this.trigger('updated', data, Object.keys(data));
                    resolve();
                    Gikam.buttonText = null;
                })
                .catch(() => {
                    reject();
                });
        });
    }

    enableAutoSave() {
        this.canAutoSave = true;
    }

    disableAutoSave() {
        this.canAutoSave = false;
    }

    initReadonly() {
        if (this.options.readonly === true) {
            this.options.columns.forEach(item => {
                item.readonly = true;
                item.editor = false;
            });
        }
    }

    /**
     * @description 清除验证内容
     * @public
     * @param {array} fields 需要清除验证的fields字段
     * @param {array} validators 需要清除验证内容
     * @memberof Grid
     */
    removeFieldsValidator(fields, validators) {
        this.errorFields = this.errorFields.filter(errField => {
            return !fields.includes(errField['field']);
        });
        const _this = this;
        Gikam.each(fields, function(index, field) {
            Gikam.each(_this.validators, function(key, value) {
                if (key === field) {
                    for (let i = value.length - 1; i > -1; i--) {
                        validators.indexOf(value[i].type) > -1 && value.splice(i, 1);
                    }
                }
                const column = _this.options.columns.filter(item => item.field === field)[0];
                for (let j = column.validators.length - 1; j > -1; j--) {
                    validators.indexOf(column.validators[j]) > -1 && column.validators.splice(j, 1);
                }
            });
        });
    }

    /**
     * @description 增加验证内容
     * @public
     * @param {array} fields 需要增加验证的fields字段
     * @param {array} validators 需要增加验证内容
     * @memberof Grid
     */
    addFieldsValidator(fields, validators) {
        var _this = this;
        fields.forEach(field => {
            for (let i = 0; i < _this.options.columns.length; i++) {
                let item = _this.options.columns[i];
                if (item.field === field) {
                    if (Gikam.isEmpty(item.validators)) {
                        _this.model.$set(item, 'validators', validators);
                    } else {
                        item.validators = validators;
                    }
                    _this.registerColumnValidators(item);
                    return false;
                }
            }
        });
    }

    registerValidators() {
        let _this = this;
        this.options.columns
            .filter(function(item) {
                return Gikam.isNotEmpty(item.validators);
            })
            .forEach(function(item) {
                _this.registerColumnValidators(item);
            });
        return this;
    }

    registerColumnValidators(item) {
        const _this = this;
        this.validators[item.field] = [];
        item.validators.forEach(function(name) {
            let validator = {};
            if (Gikam.isPlainObject(name)) {
                Gikam.extend(validator, name);
            } else if (name.indexOf('strLength') === 0) {
                Gikam.extend(validator, {
                    type: 'strLength',
                    rule: name.replace('strLength', '')
                });
            } else if (name.indexOf('numRange') === 0) {
                Gikam.extend(validator, {
                    type: 'numRange',
                    rule: name.replace('numRange', '')
                });
            } else if (name.indexOf('remote') === 0) {
                Gikam.extend(validator, {
                    type: 'remote',
                    rule: name.replace(/remote|\[|]/g, '')
                });
            } else if (name.indexOf('unique') === 0) {
                Gikam.extend(validator, {
                    type: 'unique',
                    rule: name.replace(/unique/, '').replace(/\[|]/g, '')
                });
            } else {
                Gikam.extend(validator, {
                    type: name
                });
            }
            validator.title = item.title;
            _this.validators[item.field].push(validator);
        });
    }

    setDefaultOptions(options) {
        Gikam.extend(true, defaultOptions, options.defaultOptions);
    }

    getCheckedRowIndex() {
        return this.store.state.checkedRowKeys.map(key => {
            const rowData = this.dataMapper[key];
            return GridUtils.getRowVueState(rowData, 'rowIndex');
        });
    }

    sortData(data) {
        const orderMap = this.getOrderMap();
        const len = Object.keys(orderMap).length;
        len &&
            data.sort((a, b) => {
                let n = 0;
                for (const key in orderMap) {
                    const order = orderMap[key];
                    n++;
                    if (a[key] !== b[key] || n === len) {
                        const n = a[key] >= b[key] ? 1 : -1;
                        const o = order === 'asc' ? 1 : -1;
                        return n * o;
                    }
                }
            });
    }

    /**
     * @description 动态刷新表格列
     * @public
     * @param {Array} columns 新的字段数组
     * @returns {Deferred}
     * @memberof Grid
     */
    refreshColumns(columns) {
        const def = Gikam.getDeferred();
        this.canAutoSave = false;
        this.cacheSelectItems(columns).done(() => {
            this.store.commit('refreshColumnsConfig', columns);
            this.initColumnsGroupMap();
            this.caseSelectValue();
            this.model.$nextTick(() => {
                this.store.commit('changeScrollLeft', 0);
                this.canAutoSave = true;
                def.resolve();
            });
        });
        return def;
    }

    /**
     * @description 获取快捷查询的条件
     * @private
     * @memberof Grid
     */
    getFilterRequestData() {
        const data = {};
        const filterData = Gikam.deepExtend(this.model.$refs.vm.$refs.header.filterData);
        for (let key in filterData) {
            if (Gikam.isNotEmpty(filterData[key])) {
                data[key] = filterData[key];
            }
        }
        return Object.keys(data).length === 0 ? null : data;
    }

    /**
     * @description 初始化请求查询条件
     * @private
     * @memberof Grid
     */
    initRequestData() {
        if (this.options.initRequest === false) {
            this.setOptions({
                requestData: {
                    //传此标志后台不进行数据查询
                    scheme_only: true
                }
            });
        }
    }

    /**
     * @description 通过id获取该条数据的索引
     * @param {String,Number} id 数据的id
     * @memberof Grid
     */
    getRowIndexById(id) {
        let index;
        Gikam.each(this.getData(), function(i) {
            if (this.id === id) {
                index = i;
                return false;
            }
        });
        return index;
    }

    /**
     * @description 获取单元格内组建
     * @public
     * @param {number/String} index 所在行
     * @param {String} field  所在列对应的field字段
     * @memberof Grid
     */
    getField(index, field) {
        return this.model.$refs.vm.$refs[index + '_' + this.getColumnsIndex(field)];
    }

    /**
     * @description 获取表头快捷查询编辑器
     * @param {*} field
     * @returns
     * @memberof Grid
     * @public
     */
    getHeadField(field) {
        return this.model.$refs.vm.$refs.header.$refs[field][0].$children[0].$children[0];
    }

    /**
     * @description 获取指定的列
     * @public
     * @param {*} fieldName
     * @returns
     * @memberof Grid
     */
    getColumn(fieldName) {
        return new GridColumn(this, fieldName);
    }

    /**
     * @description 通过数据id，获取索引
     * @public
     * @param {number/String} dataId 数据id
     * @memberof Grid
     */
    getIndexByDataId(dataId) {
        let index;
        Gikam.each(this.options.data, function(i) {
            if (this.id === dataId) {
                index = i;
                return true;
            }
        });
        return index;
    }

    /**
     * @description 激活单元格组件
     * @public
     * @param {number/String} index 所在行
     * @param {String} field  所在列对应的field字段
     * @memberof Grid
     */
    focusField(index, field) {
        const _field = this.getField(index, field);
        if (Gikam.isEmpty(_field) || _field.options.readonly === true) {
            return;
        }
        const { rowIndex, cellIndex } = _field;
        this.baseFocusField(rowIndex, cellIndex, _field);
    }

    /**
     * @description 激活单元格组件
     * @private
     */
    baseFocusField(rowIndex, cellIndex, field) {
        if (field.activeCell instanceof Function !== true) {
            return;
        }
        if (typeof rowIndex === 'number' && typeof cellIndex === 'number') {
            const scrollRes = this.model.$refs.vm.handleCursorPosition(rowIndex, cellIndex, field);
            if (scrollRes) {
                setTimeout(() => {
                    field.activeCell && field.activeCell();
                }, 500);
            } else {
                field.activeCell && field.activeCell();
            }
        }
    }

    /**
     * @description 根据field 获取所在列的下表
     * @private
     * @param {String} field 需要查找的列的field字段
     * @memberof Grid
     */
    getColumnsIndex(field) {
        const columns = this.store.state.columns || [];
        for (let i = 0; i < columns.length; i++) {
            if (columns[i].field === field) {
                return i;
            }
        }
    }

    /**
     * @description 重新刷新Grid分组
     * @public
     * @param {分组参数} param {fields:[field1,field2],formatter:function(){}}
     * @memberof Grid
     */
    refreshGroup(options) {
        this.options.group = options;
        this.store.commit('setGroupOptions', options);
        this.refresh();
    }

    /**
     * @description 刷新右键菜单
     * @public
     * @param {Array} menu 菜单列表
     * @memberof Grid
     */
    refreshContextmenu(menu) {
        this.store.commit('updateContextmenu', menu);
    }
    /**
     * @description 前端筛选
     * @public
     * @memberof Grid
     */
    pageSearchGrid() {
        const requestKeys = Object.keys(this.pageRequest);
        let newData = [...this.data];
        if (Gikam.isEmpty(requestKeys)) {
            this.refreshByData({ rows: newData, initPageData: false });
        } else {
            Gikam.each(requestKeys, (_index, key) => {
                if (Gikam.isEmpty(newData)) {
                    newData = [];
                    return false;
                }
                const condition = this.pageRequest[key];
                if (condition.column.type === 'filterDateField') {
                    newData = this.$queryTime(newData, key, condition);
                } else {
                    newData = this.$queryNormal(newData, key, condition);
                }
            });
            this.refreshByData({ rows: newData, initPageData: false });
        }
    }

    /**
     * @description 前端筛选初始化相应数据
     * @private
     * @memberof Grid
     */
    $initPageSearch(data) {
        if (data && Gikam.isFalse(data.initPageData)) {
            return;
        }
        this.data = [...data.rows];
        this.pageRequest = {};
        // this.model.$nextTick(()=>{
        //     const header = this.model.$refs.vm.$refs.header;
        //     for (let name in header.$refs) {
        //         if(typeof(header.$refs[name].value) !== 'undefined') {
        //             header.$refs[name].value = ''
        //         }
        //     }
        // })
    }

    /**
     * @description 前端筛选条件存储与删除
     * @private
     * @param {object} 存储的键名, 筛选值, 当前列的配置参数, select时的值
     * @memberof Grid
     */
    $setPageRequest({ field, value, column, selectText }) {
        if (Gikam.isEmpty(value)) {
            delete this.pageRequest[field];
        } else {
            this.pageRequest[field] = { value, column, selectText };
        }
    }

    /**
     * @description 获取单元格值
     * @private
     * @memberof Grid
     */
    $getFieldValue(row, key) {
        if (key.indexOf('ext$.') === 0) {
            return row.ext$[key.replace('ext$.', '')];
        } else {
            return row[key];
        }
    }

    /**
     * @description 时间框筛选
     * @private
     * @memberof Grid
     */
    $queryTime(rows, key, condition) {
        return rows.filter(item => {
            const targetValue = this.$getFieldValue(item, key) && this.$getFieldValue(item, key).split(' ')[0];
            if (Gikam.isEmpty(targetValue)) {
                return false;
            }
            const conditionValue = condition.value.split('~');
            let result;
            if (Gikam.isEmpty(conditionValue[1])) {
                const firstR = this.$targetValueIsBig(targetValue, conditionValue[0]);
                result = Gikam.isTrue(firstR) ? true : false;
            } else if (Gikam.isEmpty(conditionValue[0])) {
                const secondR = this.$targetValueIsBig(targetValue, conditionValue[1]);
                result = Gikam.isFalse(secondR) ? true : false;
            } else {
                const firstR = this.$targetValueIsBig(targetValue, conditionValue[0]);
                const secondR = this.$targetValueIsBig(targetValue, conditionValue[1]);
                result = (firstR && !secondR) || (secondR && !firstR);
            }
            return result;
        });
    }

    /**
     * @description 时间框比较大小的基本函数
     * @private
     * @memberof Grid
     */
    $targetValueIsBig(targetValue, conditionValue) {
        const targetArr = targetValue && targetValue.split('-');
        const conditionArr = conditionValue.split('-');
        while (Gikam.isNotEmpty(targetArr)) {
            const isBig = targetArr.shift();
            const isSmall = conditionArr.shift();
            if (0 > isBig - isSmall) {
                return false;
            } else if (0 < isBig - isSmall) {
                return true;
            }
        }
        return true;
    }

    /**
     * @description 除时间框之外的筛选
     * @private
     * @memberof Grid
     */
    $queryNormal(rows, key, condition) {
        return rows.filter((item, index) => {
            let targetValue = this.$getFieldValue(item, key);
            let conditionValue = condition.value;
            if (condition.column.type === 'selectField') {
                conditionValue = condition.selectText;
                Gikam.each(condition.column.items, function() {
                    if (this.value === targetValue) {
                        targetValue = this.text;
                        return false;
                    }
                });
            }

            if (Gikam.isNotEmpty(condition.column.formatter)) {
                targetValue =
                    condition.column.type === 'selectField'
                        ? condition.column.formatter(index, targetValue, item, condition.selectText)
                        : condition.column.type === 'treeField'
                        ? condition.column.formatter(item)
                        : condition.column.formatter(index, targetValue, item);
            }
            return pinyinMatch.match(targetValue, conditionValue);
        });
    }

    /**
     * @description 滚动至刷新前选中项
     * @public
     * @memberof Grid
     */
    selectLatestSelectedRow() {
        const lastCheckedRowKeys = this.store.state.lastCheckedRowKeys;
        if (Gikam.isEmpty(this.getTotalData())) {
            return;
        }
        if (Gikam.isEmpty(lastCheckedRowKeys)) {
            return;
        }
        let minRowIndex = this.getTotalData().length - 1;
        let minRowDataKey = null;
        lastCheckedRowKeys.forEach(key => {
            const rowData = this.dataMapper[key];
            const rowIndex = GridUtils.getRowVueState(rowData, 'rowIndex');
            const rowDataKey = GridUtils.getRowVueState(rowData, 'key');
            GridUtils.checkRow(rowData, this, { triggerEvent: false });
            this.store.commit('checkRow', { rowData, triggerEvent: false });
            if (rowIndex < minRowIndex) {
                minRowIndex = rowIndex;
                minRowDataKey = rowDataKey;
            }
        });
        this.scrollToRowId(minRowDataKey);
        if (!this.options.checkOnActive && !this.options.checkOneOnActive) {
            this.activeRowById(minRowDataKey);
        }
    }

    /**
     * @description 滚动至刷新前选中项
     * @public
     * @memberof Grid
     */
    activateLatestActivatedRow() {
        this.activeRowById(this.store.state.lastActiveRowDataKey);
    }

    /**
     * @description 通过id激活行
     * @param {*} id
     * @memberof Grid
     */
    activeRowById(id) {
        const rowData = this.dataMapper[id];
        const rowIndex = GridUtils.getRowVueState(rowData, 'rowIndex');
        this.store.commit('activeRow', { rowData, rowIndex });
        this.scrollToRowId(rowData.id);
    }

    /**
     * @description 获取当前正在操作的单元格组件 没有返回null
     * @public
     * @memberof Grid
     */
    getActiveEditor() {
        if (Gikam.isEmpty(this.store.state.editingChildren.coordinate)) {
            return null;
        }

        return this.model.$refs.vm.$refs[this.store.state.editingChildren.coordinate.join('_')];
    }

    getActiveCell() {
        if (Gikam.isEmpty(this.options.id) || Gikam.isEmpty(Gikam.globalActiveField)) {
            return {
                setValue() {
                    Gikam.error('当前系统不存在激活的单元格');
                }
            };
        }
        const cell = Gikam.globalActiveField[this.options.id];
        if (Gikam.isEmpty(cell)) {
            return {
                setValue() {
                    Gikam.error('当前系统不存在激活的单元格');
                }
            };
        }
        return {
            $Vue: cell,
            setValue(value) {
                if (Gikam.isEmpty(value)) {
                    return Gikam.error('未识别需要设置的值');
                }
                this.$Vue.value = value;
            }
        };
    }

    /**
     * @description 禁止不同用户对同一条数据同时编辑
     * @private
     * @memberof Grid
     */
    checkEditable() {
        const coordinate = this.store.state.editingChildren.coordinate;
        const gridId = this.options.id;
        const dataId = this.options.data[coordinate[0]].id;
        Gikam.isEmpty(this.checkEditorFields) &&
            this.options.columns.forEach(column => {
                column.field && !column.readonly && this.checkEditorFields.push(column.field);
            });
        Gikam.post(Gikam.IFM_CONTEXT + `/secure/core/module/gikam/repositories/mark-editable/${gridId}$${dataId}`).then(
            res => {
                if (!res) {
                    if (
                        ['sign', 'choose', 'richTextChoose', 'cron'].indexOf(this.store.state.editingChildren.type) > -1
                    ) {
                        Gikam.getLastModal() && Gikam.getLastModal().close();
                    } else {
                        Gikam.simulatedEvent(document, 'mousewheel');
                        Gikam.simulatedEvent(document, 'click');
                    }
                    this.refreshRowByIndex(coordinate[0]);
                    this.toFieldsReadonly(coordinate[0], this.checkEditorFields);
                    this.preEditingIndex = coordinate[0];
                    Gikam.alert(I18N.prop('grid.checkEditable'));
                } else {
                    clearInterval(this.timer);
                    this.timer = null;
                    this.toFieldsEdit(this.preEditingIndex, this.checkEditorFields);
                    this.preEditingIndex = null;
                }
            }
        );
    }

    /**
     * @description 获取焦点后循环触发checkEditable
     * @private
     * @memberof Grid
     */
    repeatCheckEditor() {
        const coordinate = this.store.state.editingChildren.coordinate;
        if (Gikam.isEmpty(coordinate)) return;
        const gridId = this.options.id;
        const dataId = this.options.data[coordinate[0]].id;
        if (!gridId || !dataId) return;
        if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
        }
        this.checkEditable();
        this.timer = setInterval(() => {
            this.checkEditable();
        }, 7e3);
    }

    /**
     *
     * @description 通过查询数据，存储新增或者保存url
     * @private
     * @param {*} xhr
     * @memberof Grid
     */
    storeInstantSavePath(xhr) {
        if (this.options.instantSavePath) {
            return;
        }
        this.options.instantSavePath = Gikam.IFM_CONTEXT + xhr.getResponseHeader('GIKAM-INSTANT-SAVE-PATH');
    }

    /**
     * @description 获取实时保存路径
     * @private
     * @param {*} data
     * @returns
     * @memberof Grid
     */
    getInstantSavePath(data) {
        if (Gikam.isEmpty(this.options.instantSavePath)) {
            return '';
        }
        return Gikam.printf(this.options.instantSavePath, data);
    }

    /**
     * @description 获取行专列字段数据{a:1,ext$:{field_ext$:{}}}
     * @param {*} index
     * @param {*} fieldName
     * @memberof Grid
     */
    getRowToColumnFieldData(index, field) {
        const row = this.options.data[index];
        if (!row.ext$) {
            return;
        }
        return row.ext$[field + '_ext$'];
    }

    /**
     * @description editorInvisible状态下 设置当前编辑的节点
     *
     */
    _setCurrentEditor(editor) {
        if (Gikam.isEmpty(editor) && Gikam.isNotEmpty(this.currentEditor)) {
            this.currentEditor.invisible = true;
            this.currentEditor.validateResult = true;
        }
        this.currentEditor = editor;
    }
    /**
     * @description editorInvisible状态下 获取当前编辑的节点
     *
     */
    _getCurrentEditor() {
        return this.currentEditor;
    }

    /**
     * @description 在移动端修改列宽时给全局添加遮罩
     *
     */
    _addMask() {
        const _this = this;
        _this.gridMask = new Vue({
            el: Gikam.createDom('div', _this.model.$el.parentNode),
            components: {
                GridMask: () => import('../vue/gridMask.vue')
            },
            mounted() {
                _this.model.$refs.vm.$refs.header.updateResizeField(true);
                document.querySelectorAll('.scroll-content').forEach(item => {
                    item.style.transform = '';
                });
            },
            beforeDestroy() {
                _this.model.$refs.vm.$refs.header.updateResizeField();
            },
            methods: {
                clear() {
                    Gikam.removeDom(this.$el);
                    this.$destroy();
                    _this.gridMask = null;
                }
            },
            render() {
                return <grid-mask propDom={_this.model.$el} onClose={this.clear} />;
            }
        });
    }

    /**
     * @private
     * @description
     * @memberof Grid
     */
    validateExistsError(rows, noModal) {
        if (Gikam.isNotEmpty(rows)) {
            this.errorFields = [];
        }
        const errorMessages = this.errorFields.map(error => {
            return {
                title: error.title,
                message: error.message
            };
        });
        if (Gikam.isNotEmpty(errorMessages)) {
            !noModal && this.showValidateMessage(errorMessages);
            return false;
        }
        return true;
    }

    /**
     * @public
     * @description 清楚校验字段缓存
     * @memberof Grid
     */
    cleanValidateCache() {
        this.errorFields = [];
    }

    init() {
        this.registerValidators();
        this.initRequestData();
        this.watchColumns();
        this.formatterPageList();
        this.initReadonly();
        this.createModel();
        this.$initPageSearch({ rows: this.options.data });
        this.initRowActiveDataLock();
        this.getAdvSearchConfig();
    }

    /**
     * @description 字段值改变
     * @memberof Form
     * @private
     */
    // eslint-disable-next-line complexity
    filedChangeHandle({ field, value, index }) {
        if (this.$changeFields['__ob__']) {
            delete this.$changeFields['__ob__'];
        }
        let isFieldChange = Gikam.getFieldValue(this.options.data[index], field) + '' !== value + '' ? true : false;
        const changeRow = this.$changeFields[index];
        if (value === '' && changeRow && changeRow[field] === undefined) {
            isFieldChange = false;
        }
        if (isFieldChange === false && changeRow && Gikam.isNotEmpty(changeRow[field])) {
            delete changeRow[field];
            if (Gikam.isEmptyObject(changeRow)) {
                delete this.$changeFields[index];
            }
        } else {
            if (changeRow) {
                changeRow[field] = value;
            } else {
                this.$changeFields[index] = { [field]: value };
            }
        }
        const changeFlag = Gikam.isEmptyObject(this.$changeFields) ? false : true;
        this.$window && this.$window.changeSaveButtonPrompt(this, changeFlag);
    }

    /**
     * @description 控制工具栏显示
     *
     */
    showToolbar() {
        this.options.toolbarHidden = false;
    }

    /**
     * @description 控制工具栏隐藏
     *
     */
    hideToolbar() {
        this.options.toolbarHidden = true;
    }

    /**
     * @description 批量下载
     *
     */
    batchDownload(dbTable) {
        if (!dbTable) {
            return;
        }
        const selections = this.getSelections();
        const url = Gikam.printf(Gikam.IFM_CONTEXT + '/core/module/item/files/action/pack/{table}', {
            table: dbTable
        });
        Gikam.postText(url, Gikam.getJsonWrapper({}, ['', selections])).done(function(downloadUrl) {
            Gikam.download(Gikam.IFM_CONTEXT + downloadUrl);
        });
    }

    /**
     * @private
     * @description 用于页面配置刷新columns
     * @memberof Grid
     */
    refreshColumnsByConfig = refreshColumnsByConfig;

    /**
     * @private
     * @description 页面滚动至底部
     * @param {*} number
     * @memberof Grid
     */
    scrollToBottom() {
        const scroll = this.model.$refs.vm.$refs.vs;
        if (!scroll) {
            return;
        }
        const scrollTop = scroll.contentHeight - scroll.wrapperHeight;
        scroll.scrollTo({ y: scrollTop });
    }

    /**
     * @private
     * @description 页面滚动至最右侧
     * @param {*} number
     * @memberof Grid
     */
    scrollToRight() {
        const scroll = this.model.$refs.vm.$refs.vs;
        if (!scroll) {
            return;
        }
        const scrollRight = scroll.contentWidth - scroll.wrapperWidth;
        scroll.scrollTo({ x: scrollRight });
    }

    /**
     * @public
     * @description 滚动至相应位置
     * @param {*} number
     * @memberof Grid
     */
    scrollTo(param = { x: 0, y: 0 }) {
        const scroll = this.model.$refs.vm.$refs.vs;
        scroll?.scrollTo(param, 0);
    }

    /**
     * @private
     * @description 获取合计值对象
     * @memberof Grid
     */
    getSumData() {
        return this.options.totalMap;
    }

    /**
     * @private
     * @description
     * @memberof Form
     */
    initDataLock() {
        if (!this.$window) {
            return;
        }
        if (this.$window.isCompLocked(this.options)) {
            this.model.$refs.vm.locked = true;
        } else {
            this.model.$refs.vm.locked = false;
        }
    }

    /**
     * @private
     * @description
     * @memberof Grid
     */
    initRowActiveDataLock() {
        if (!this.$window) {
            return;
        }
        if (this.$window.options.dataLock && this.options.dataLockWatch && this.options.onRowActive) {
            const _rowActive = this.listeners.rowActive;
            this.listeners.rowActive = async (index, rowData) => {
                await this.$window.lockDataByComp(this.options, rowData.id);
                _rowActive.call(this, index, rowData);
            };
        }
    }

    /**
     * @description 获取编辑器参数
     * @returns
     * @memberof Grid
     */
    getPageEditorOptions() {
        const options = Gikam.deepExtend(this.options);
        const config = {};
        options.columns.forEach(column => {
            column.category && delete column.items;
        });
        options.hiddenFields.forEach(column => {
            column.category && delete column.items;
        });
        const properties = ['columns', 'dbTable', 'hiddenFields'];
        for (const property of properties) {
            config[property] = options[property];
        }
        return config;
    }

    /**
     * @public
     * @description 清空编辑器参数
     * @memberof Grid
     */
    cleanHeadRequestData() {
        this.store.commit('setHeadRequestData', {});
    }

    /**
     * @private
     * @description 在每个grid实例初始化时去获取当前的高级查询配置
     * @memberof Grid
     */
    // 在每个grid实例初始化时去获取当前的高级查询配置
    getAdvSearchConfig() {
        if (Grid.advSearchConfigs) {
            this.options.advSearchConfig = Grid.advSearchConfigs[this.options.id] || {};
            return;
        }
        this.options.advSearchConfig = {};
    }

    /**
     * @description 存储所有高级查询数据
     * @memberof Grid
     */
    static setAdvSearchConfig(configs) {
        if (Gikam.isEmpty(this.advSearchConfigs)) {
            this.advSearchConfigs = {};
        }
        configs.forEach(item => {
            this.advSearchConfigs[item.blockId] = item;
        });
    }

    /**
     * @private
     * @description 是否是懒加载
     * @memberof Grid
     */
    isLazyLoad() {
        return this.options.page === false && this.options.lazyLoad;
    }

    /**
     * @description 滚动到相应数据处
     * @memberof Grid
     */
    scrollToRowId(rowDataId) {
        const rowDom = this.$rowManager[rowDataId]?.$el;
        if (!rowDom) {
            return;
        }
        const index = this.getRowIndexById(rowDataId);
        const $refs = this.model.$refs.vm.$refs;
        const cellTr = $refs['bodyTable'].rows[index];
        const cellTrOffsetTop = cellTr.offsetTop;
        $refs.vs.scrollTo({
            y: cellTrOffsetTop - 50
        });
    }

    /**
     * @description 根据索引激活列
     * @param {*} index
     * @memberof Grid
     */
    setActivedColumn(index) {
        this.store.commit('chooseColumns/changeColumnsSelectIndex', index - 1);
    }

    /**
     * @description 刷新Toolbar
     * @param {*} toolbar
     * @memberof Grid
     */
    refreshToolbar(toolbar) {
        this.options.toolbar = toolbar;
        this.$gridToolbar.$forceUpdate();
    }

    /**
     * @description 清空过滤条件
     * @memberof Grid
     */
    cleanRequestData(ignoreKeys = []) {
        GridUtils.cleanRequestData(ignoreKeys, this);
    }

    /**
     * @description 清空过滤条件
     * @memberof Grid
     */
    cleanOrderData(ignoreKeys = []) {
        GridUtils.cleanOrderData(ignoreKeys, this);
    }

    $beforeDestroy() {
        if (top.Gikam.activeGrid === this) {
            top.Gikam.activeGrid = null;
        }
    }

    /**
     * @description 通过id获取行数据
     * @public
     * @param {*} id
     * @memberof Grid
     */
    getRowDataById(id) {
        return Gikam.deepExtend(this.dataMapper[id]);
    }
}
